import {
    AlertTypes,
    BaseGenericItemsStore,
    GenericItemsForm,
    GenericItemsUtils,
    IGetAllParams,
    Spinner,
    Grid,
    Mui,
    MuiIcons
} from "@leap4/frontend";
import type {GridColDef, GridRenderCellParams} from "@leap4/frontend";
import {baseBackendRoute} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";
import {Link} from "react-router-dom";
import {RootState} from "../../../interfaces/root-state.interface";
import {connect, useDispatch} from "react-redux";
import React, {useState} from "react";
import {deleteOwnership} from "../../../actions/users";
import {setAlert} from "../../../actions/alert";
import {IPublisherLogins} from "../../publisherLogins/interfaces/IPublisherLogins";

const {IconButton} = Mui;
const {Groups: GroupsIcon, DeleteForever: DeleteForeverIcon} = MuiIcons;


export interface IPublisherLoginsProps {
    currentPublisherLogin: IPublisherLogins
}

const fields = {
    ORGANIZATION: 1,
    DATE: 1,
    PUBLISHER_TAG: 1,
    SUPPLY_TAG: 1,
    VALUE: 1,
    DELETE: 1,
}

const getParams: IGetAllParams = {
    fields
}
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});
const connector = connect(mapStateToProps);
let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>

const OwnershipDashboard = (props: IPublisherLoginsProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const dispatch = useDispatch();


    function handleDelete(id: string) {
        (async () => {
            setIsLoading(true)
            try {
                await deleteOwnership(dispatch, id);
            } catch (err) {
                setAlert(err.toString(), AlertTypes.FAILURE)
            } finally {
                setIsLoading(false)
            }
        })()
    }

    function setStoreAndColumns() {
        const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
            baseUrl: `${baseBackendRoute + urlService.ownerships()}`
        }, fields, {
            name: {editLinkFunc: () => urlService.getOwnershipsByOrgId(props.currentPublisherLogin.publisherId)},
            isActive: {},
            updated: {},
            created: {},
        })
        store = storeAndColumns.store;
        columns = storeAndColumns.columns;
        const nameCol = columns.find(x => x.field === "ORGANIZATION");
        const dateCol = columns.find(x => x.field === "DATE");
        const publisherTagCol = columns.find(x => x.field === "PUBLISHER_TAG");
        const supplyTagCol = columns.find(x => x.field === "SUPPLY_TAG");
        const valueCol = columns.find(x => x.field === "VALUE");
        const deleteCol = columns.find(x => x.field === "DELETE");
        nameCol.width = 130;
        valueCol.width = 100;
        dateCol.width = 100;
        supplyTagCol.width = 300;
        nameCol.renderCell = (params: GridRenderCellParams) => {
            return <Link
                to={urlService.editOrganization(params.row.orgId)}>
                <strong>{params.row.orgName}</strong></Link>
        }
        dateCol.renderCell = (params: GridRenderCellParams) => {
            return <>{params.row.timestamp.slice(0, 10)}</>
        }
        publisherTagCol.renderCell = (params: GridRenderCellParams) => {
            return <>{params.row.publisherTag}</>
        }
        supplyTagCol.renderCell = (params: GridRenderCellParams) => {
            return <>{params.row.supplyTag}</>
        }
        valueCol.renderCell = (params: GridRenderCellParams) => {
            if (params.row.ownershipValue === 0) {
                return <span><strong>{params.row.percent + "%"} </strong> </span>
            }
            return <span><strong>{params.row.ownershipValue}</strong> </span>
        }
        deleteCol.renderCell = (params: GridRenderCellParams) => {
            return <IconButton onClick={() => {handleDelete(params.row._id)}}><DeleteForeverIcon/></IconButton>
        }
    }

    setStoreAndColumns();
    return (
        <>

                <Grid item width='100%' margin={"0px"}>
                    {isLoading ? (
                    <Spinner/>
                ) : (
                    <GenericItemsForm
                        organization={"1"}
                        columns={columns}
                        store={store}
                        breadcrumbs={{
                            link: urlService.publisherLogins(),
                            text: "Ownerships dashboard",
                            icon: <GroupsIcon/>
                        }}
                        tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
                        getAllParams={getParams}
                        createButton={{to: "ownership/add", text: "Add ownership"}}
                    />
                    )}
                </Grid>

        </>
    )
}

export default connector(OwnershipDashboard)